module.exports = __webpack_public_path__ + "static/img/hua4.b91cc28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hua4.png
// module id = EqIo
// module chunks = 1